import { useEffect } from "react";

type PageMetaProps = {
  title: string;
  description?: string;
  robots?: string;
};

export default function PageMeta({ title, description, robots }: PageMetaProps) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const descEl = document.querySelector('meta[name="description"]');
    const previousDescription = descEl?.getAttribute("content") ?? null;
    if (description && descEl) descEl.setAttribute("content", description);

    const robotsEl = document.querySelector('meta[name="robots"]');
    const previousRobots = robotsEl?.getAttribute("content") ?? null;
    if (robots && robotsEl) robotsEl.setAttribute("content", robots);

    return () => {
      document.title = previousTitle;
      if (descEl && previousDescription !== null) {
        descEl.setAttribute("content", previousDescription);
      }
      if (robotsEl && previousRobots !== null) {
        robotsEl.setAttribute("content", previousRobots);
      }
    };
  }, [title, description, robots]);

  return null;
}
